(() => {
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

  const initializeFooter = (footer) => {
    if (!footer || footer.dataset.elo23FooterReady === "true") return;
    const logo = footer.querySelector("[data-elo23-footer-logo]");
    if (!logo) return;
    footer.dataset.elo23FooterReady = "true";
    let frame = 0;

    const update = () => {
      frame = 0;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        logo.style.setProperty("--elo23-footer-logo-scale", "1");
        return;
      }
      const bounds = logo.getBoundingClientRect();
      const progress = clamp(
        (bounds.top + bounds.height * 0.28) / (window.innerHeight * 1.35),
      );
      logo.style.setProperty(
        "--elo23-footer-logo-scale",
        (1 + progress * 0.2).toFixed(4),
      );
    };

    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate, { passive: true });
    update();
  };

  const initializeProductRail = (dots) => {
    if (!dots || dots.dataset.elo23DotsReady === "true") return;
    const scope = dots.closest(".elo-home__products");
    const rail = scope?.querySelector("[data-elo-product-rail]");
    const cards = Array.from(rail?.querySelectorAll(".elo-product-card") || []);
    const buttons = Array.from(dots.querySelectorAll("[data-elo23-home-dot]"));
    const previous = scope?.querySelector("[data-elo-rail-prev]");
    const next = scope?.querySelector("[data-elo-rail-next]");
    if (!rail || cards.length < 2 || buttons.length !== cards.length) return;
    dots.dataset.elo23DotsReady = "true";
    let frame = 0;

    const nearestIndex = () => {
      const padding = Number.parseFloat(getComputedStyle(rail).paddingInlineStart) || 0;
      const railStart = rail.scrollLeft + padding;
      let index = 0;
      let distance = Infinity;
      cards.forEach((card, cardIndex) => {
        const nextDistance = Math.abs(card.offsetLeft - railStart);
        if (nextDistance < distance) {
          distance = nextDistance;
          index = cardIndex;
        }
      });
      return index;
    };

    const update = () => {
      frame = 0;
      const index = nearestIndex();
      buttons.forEach((button, buttonIndex) => {
        const active = buttonIndex === index;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-current", active ? "true" : "false");
      });
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === cards.length - 1;
    };

    rail.addEventListener(
      "scroll",
      () => {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      },
      { passive: true },
    );

    buttons.forEach((button, index) => {
      button.addEventListener("click", () => {
        const padding = Number.parseFloat(getComputedStyle(rail).paddingInlineStart) || 0;
        rail.scrollTo({
          left: Math.max(0, cards[index].offsetLeft - padding),
          behavior: "smooth",
        });
      });
    });

    if ("ResizeObserver" in window) new ResizeObserver(update).observe(rail);
    update();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll("[data-elo23-footer]").forEach(initializeFooter);
    scope.querySelectorAll("[data-elo23-home-dots]").forEach(initializeProductRail);
  };

  document.addEventListener("DOMContentLoaded", () => initializeAll());
  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
